<template>
  <transition name="modal" :duration="duration">
    <div v-show="show" class="modal-container">
      <div class="modal" @click.self="clickMask">
        <div class="modal-dialog" :class="modalClass">
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <slot name="header">
                <div class="modal-title">
                  <slot name="title"></slot>
                </div>
              </slot>
            </div>
            <!--Container-->
            <div class="modal-body">
              <slot></slot>
            </div>
            <!--Footer-->
            <div class="modal-footer">
              <slot name="footer">
                <button type="button" :class="cancelClass" @click="cancel">{{ cancelText}}</button>
                <button
                  v-if="!okText.includes('!SHOW')"
                  type="button"
                  :class="okClass"
                  @click="ok"
                >{{okText}}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop"></div>
    </div>
  </transition>
</template>

<script>
import { bus } from "../../main";
export default {
  name: "drugo-stanje",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    zatvori: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      duration: 500,
      zatvor: this.zatvori
    };
  },
  computed: {
    modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    );
  },
  watch: {
    show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    }
  },
  methods: {
    ok() {
      bus.$emit("DrugoStanjeOn");

      this.$emit("ok");

      this.show = false;
    },
    cancel() {
      bus.$emit("DrugoStanjeOff");
      this.$emit("cancel");

      this.show = false;
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";

.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

.modal-header {
  height: $modal-header-height;
  padding: $modal-header-padding-y $modal-header-padding-x;
  border-bottom: $modal-header-border;
  font-size: $font-size-larger;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: $modal-content-border-radius;
}

.modal-footer {
  justify-content: center;
  padding: 0 $modal-inner-padding;
  padding-bottom: calc(
    #{$modal-inner-padding} - #{$modal-footer-btns-padding-bottom}
  );
  flex-wrap: wrap;
  .btn {
    margin: 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom
      $modal-footer-btns-margin-x;
  }
}
.modal-dialog {
  box-shadow: $modal-content-box-shadow-sm-up;
}
</style>



// WEBPACK FOOTER //
// src/components/02_samples/DrugoStanje.vue